import {Form, InputNumber} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import IField from "../../../../../../model/interface/dataStorage/IField";

export interface IFieldPriceOptions {
    numberPrecision?: number
}

interface IProps extends IFieldOptionsEditorProps {
    field: IField
}

interface IState {
}

class FieldPriceOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {buildFieldName, field} = this.props
        return (
            <div>
                <Form.Item label={'Zaokrouhlit na'} name={buildFieldName('numberPrecision')}>
                    <InputNumber min={0} max={Number.MAX_SAFE_INTEGER}/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldPriceOptionsEditor